import React, { useEffect, useState } from 'react';

const COOKIE_CONSENT_KEY = 'cookieConsentGiven';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      width: '100%',
      background: '#1a202c',
      color: '#fff',
      padding: '1rem',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 -2px 8px rgba(0,0,0,0.1)'
    }}>
      <span style={{ marginRight: '1.5rem' }}>
        This app uses only essential cookies for functionality. <a href="/privacy-policy.html" style={{ color: '#90cdf4', textDecoration: 'underline' }}>Learn more</a>.
      </span>
      <button
        onClick={handleAccept}
        style={{
          background: '#38a169',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          padding: '0.5rem 1.2rem',
          cursor: 'pointer',
          fontWeight: 600
        }}
      >
        OK
      </button>
    </div>
  );
};

export default CookieConsent; 